import Axios from "../helper/appConfig";

export const getDatasContactService = async () => {
    let branchid = localStorage.getItem("branchid");

    return Axios.get("api/branches/" + branchid);
};



export const handlePostDataService = async (value) => {
    let payload = {};
    payload["property"] = value;

    return Axios.post("api/enquiries", payload);
}